// import { useEffect, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPlus } from "@fortawesome/free-solid-svg-icons";

// import TaskReportFilter from "./TaskReportFilter";
// import TaskReportTable from "./TaskReportTable";
// import Pagination from "../../../components/common/Pagination";

// import TaskReportCreate from "./TaskReportCreate";
// import TaskReportDetail from "./TaskReportDetail";

// import { showErrorToast, showSuccessToast } from "../../../components/ConfirmDialog";
// import { getTaskReports } from "../../../api/reports/hrm/tasks_report_info";

// export default function TaskReportList() {
//   // ===================== STATE =====================
//   const [filters, setFilters] = useState({
//     keyword: "",
//     branch_id: "",
//     department_id: "",
//     from_date: "",
//     to_date: "",
//   });

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalRecords, setTotalRecords] = useState(0);

//   const [showCreate, setShowCreate] = useState(false);
//   const [showDetail, setShowDetail] = useState(false);
//   const [selectedReport, setSelectedReport] = useState(null);

//   // ===================== LOAD DATA =====================
//   const loadReports = async () => {
//     try {
//       setLoading(true);

//       const query = {
//         ...filters,
//         page: currentPage,
//         limit: pageSize,
//       };

//       const res = await getTaskReports(query);

//       setData(res?.items || []);
//       setTotalRecords(res?.total || 0);
//     } catch (err) {
//       console.error("❌ Lỗi tải danh sách báo cáo:", err);
//       showErrorToast("Không thể tải danh sách báo cáo");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadReports();
//   }, [filters, currentPage, pageSize]);

//   // ===================== RENDER =====================
//   return (
//     <div className="p-6">
//       {/* HEADER */}
//       <div className="flex items-center justify-between mb-5">
//         <h1 className="text-xl font-bold text-gray-800">Báo cáo công việc</h1>
//       </div>

//       {/* FILTER */}
//       <TaskReportFilter
//         onFilterChange={(f) => {
//           setFilters(f);
//           setCurrentPage(1);
//         }}
//         onCreateClick={() => setShowCreate(true)}
//       />

//       {/* TABLE */}
//       <TaskReportTable
//         data={data}
//         loading={loading}
//         onViewDetail={(report) => {
//           setSelectedReport(report);
//           setShowDetail(true);
//         }}
//       />

//       {/* PAGINATION */}
//       <div className="mt-4">
//         <Pagination
//           totalRecords={totalRecords}
//           currentPage={currentPage}
//           pageSize={pageSize}
//           onPageChange={setCurrentPage}
//           onPageSizeChange={(size) => {
//             setPageSize(size);
//             setCurrentPage(1);
//           }}
//         />
//       </div>

//       {/* POPUP CREATE */}
//       {showCreate && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
//           <TaskReportCreate
//             onClose={() => setShowCreate(false)}
//             onSaved={() => {
//               showSuccessToast("Đã tạo báo cáo thành công!");
//               setShowCreate(false);
//               loadReports();
//             }}
//           />
//         </div>
//       )}

//       {/* POPUP DETAIL */}
//       {showDetail && selectedReport && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
//           <TaskReportDetail report={selectedReport} onClose={() => setShowDetail(false)} />
//         </div>
//       )}
//     </div>
//   );
// }

import { useEffect, useState, useCallback } from "react";
import TaskReportFilter from "./TaskReportFilter";
import TaskReportTable from "./TaskReportTable";
import Pagination from "../../../components/common/Pagination";
import TaskReportCreate from "./TaskReportCreate";
import TaskReportDetail from "./TaskReportDetail";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/ConfirmDialog";
import { confirmDelete, DELETE_ENTITY } from "../../../utils/confirmDelete";
import {
  deleteTaskReport,
  getTaskReports,
  getTaskReportDetail,
} from "../../../api/reports/hrm/tasks_report_info";

export default function TaskReportList() {
  // ===================== UTILS =====================
  const formatDateLocal = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getDefaultFilters = () => {
    const now = new Date();
    return {
      keyword: "",
      branch_id: "",
      department_id: "",
      from_date: formatDateLocal(
        new Date(now.getFullYear(), now.getMonth(), 1)
      ),
      to_date: formatDateLocal(
        new Date(now.getFullYear(), now.getMonth() + 1, 0)
      ),
    };
  };

  // ===================== STATE =====================
  const [filters, setFilters] = useState(getDefaultFilters());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [showCreate, setShowCreate] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [deletingReport, setDeletingReport] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    try {
      const rawUser = localStorage.getItem("user");
      if (rawUser) {
        setCurrentUser(JSON.parse(rawUser));
      }
    } catch {
      setCurrentUser(null);
    }
  }, []);

  // ===================== LOAD DATA =====================
  const loadReports = useCallback(async () => {
    try {
      setLoading(true);
      const query = {
        ...filters,
        page: currentPage,
        limit: pageSize,
      };

      const res = await getTaskReports(query);

      // Đảm bảo Backend trả về { items: [], total: ... }
      setData(res?.items || []);
      setTotalRecords(res?.total || 0);
    } catch (err) {
      console.error("❌ Lỗi tải danh sách báo cáo:", err);
      showErrorToast("Không thể tải danh sách báo cáo");
    } finally {
      setLoading(false);
    }
  }, [filters, currentPage, pageSize]);

  useEffect(() => {
    loadReports();
  }, [loadReports]);

  // ===================== HANDLERS =====================
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1); // Luôn về trang 1 khi thay đổi bộ lọc
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleViewDetail = async (report) => {
    if (!report?.id) {
      setSelectedReport(report);
      setShowDetail(true);
      return;
    }

    try {
      setLoading(true);
      const detail = await getTaskReportDetail(report.id);
      setSelectedReport(detail || report);
      setShowDetail(true);
    } catch (err) {
      console.error("❌ Lỗi tải chi tiết báo cáo:", err);
      showErrorToast("Không thể tải chi tiết báo cáo");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteReport = async (report) => {
    if (!report?.id) return;
    const confirm = await confirmDelete({
      type: DELETE_ENTITY.task_report,
      name: report?.title || report?.report_date,
    });
    if (!confirm?.isConfirmed) return;

    try {
      setDeletingReport(true);
      await deleteTaskReport(report.id);
      showSuccessToast("Đã xóa báo cáo");
      setShowDetail(false);
      setSelectedReport(null);
      await loadReports();
    } catch (err) {
      console.error("❌ Lỗi xóa báo cáo:", err);
      showErrorToast(err?.message || "Không thể xóa báo cáo");
    } finally {
      setDeletingReport(false);
    }
  };

  // ===================== RENDER =====================
  return (
    <div className="p-6 bg-gray-50/50 min-h-screen">
      {/* HEADER */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-black text-gray-800 uppercase tracking-tight">
            Báo cáo công việc hàng ngày
          </h1>
          <p className="text-sm text-gray-500">
            Quản lý và theo dõi hiệu suất làm việc định kỳ
          </p>
        </div>
      </div>

      {/* FILTER SECTION */}
      <TaskReportFilter
        onFilterChange={handleFilterChange}
        onCreateClick={() => setShowCreate(true)}
      />

      {/* TABLE SECTION */}
      <div className="mt-6">
        <TaskReportTable
          data={data}
          loading={loading}
          currentPage={currentPage} // ✅ Truyền thêm trang hiện tại
          pageSize={pageSize} // ✅ Truyền thêm kích thước trang
          onViewDetail={handleViewDetail}
        />
      </div>

      {/* PAGINATION SECTION */}
      {!loading && totalRecords > 0 && (
        <Pagination
          totalRecords={totalRecords}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onPageSizeChange={(size) => {
            setPageSize(size);
            setCurrentPage(1);
          }}
        />
      )}

      {/* MODAL: TẠO MỚI */}
      {showCreate && (
        <TaskReportCreate
          onClose={() => setShowCreate(false)}
          onSaved={() => {
            showSuccessToast("Đã tạo báo cáo thành công!");
            loadReports();
          }}
        />
      )}

      {/* MODAL: CHI TIẾT */}
      {showDetail && selectedReport && (
        <TaskReportDetail
          report={selectedReport}
          currentUserId={currentUser?.id}
          deleting={deletingReport}
          onDelete={handleDeleteReport}
          onClose={() => {
            setShowDetail(false);
            setSelectedReport(null);
          }}
        />
      )}
    </div>
  );
}
